import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import cloneDeep from 'lodash/cloneDeep';
import { WebService } from '../shared/services/web.service';
import { GroupService } from '../shared/services/group.service';
import { ResourceService } from '../resource-service.service';
import { KnowledgeBaseService } from '../shared/services/knowledgebase.service';
import { CourseService } from '../shared/services/course.service';
import { UserService } from '../shared/services/user.service';
import { DataListingComponent } from '../data-listing/data-listing.component';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { Observable, from } from 'rxjs';
import { concatMap } from 'rxjs/operators';
import { KnowledgeBaseListingComponent } from '../knowledge-base-listing/knowledge-base-listing.component';
import { CourseListingComponent } from '../course-listing/course-listing.component';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzTableSortFn, NzTableSortOrder } from 'ng-zorro-antd/table';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { forkJoin } from 'rxjs';
import {fadeIn} from '../../app/shared/animation/animation.component';
import { Console } from 'console';
import { is } from 'date-fns/locale';
interface DataItem {
  access_group_id: number;
  access_group_name: string;
  user_ids: any;
  resource_ids: any;
  tag: any;
}

interface ColumnItem {
  name: string;
  sortOrder: NzTableSortOrder | null;
  sortFn: NzTableSortFn<DataItem> | null;
  sortDirections: NzTableSortOrder[];
}

@Component({
  selector: 'app-access-group',
  templateUrl: './access-group.component.html',
  styleUrls: ['./access-group.component.css'],
  animations:[fadeIn]
})
export class AccessGroupComponent {
  @ViewChild(KnowledgeBaseListingComponent)
  knowledgeBaseListingComponent: KnowledgeBaseListingComponent;
  checkedResourceItems: any = [];
  checkedR = [];
  checkedK = [];
  checkedC = [];
  checkedU = [];
  checkedKnowledgeBaseItems: any = [];
  checkedCourseItems: any = [];
  checkedUserItems: any = [];
  [x: string]: any;
  visible: boolean = false;
  accessGroupData = [];
  allChecked: boolean;
  anyChecked: boolean;
  sortName: string;
  sortValue: string;
  categoryList = [];
  userList = [];
  tagFilterList = [];
  tagList = [];
  accessGroupDataRaw = [];
  checkedData: any[];
  accessGroupFormVisible: boolean;
  accessGroupForm: FormGroup;
  categories = [];
  tableData = [];
  updateMode: boolean;
  rawUpdateData: any = {};
  updateAccessGroupId: any;
  active_status: boolean = false;
  isResourceFound: boolean;
  radioValue = '0';
  tableDataRaw = [];
  resourcesList: any;
  selectedTag: any;
  isLoading: boolean = false;
  selectedCategories: any[];
  selectedTags: any[];
  selectedResources = [];
  isNzChecked: boolean;
  checkedCheckboxIds: any;
  categoryFilterList: any[];
  submitted: boolean = false;
  filterVisible: boolean;
  loadingFlag: boolean;
  metadata: any;
  userFilterList: any[];
  accessGroupList: any;
  knowledgeBasesList: any;
  coursesList: any;
  usersList: any;
  receivedData: any[];
  resourcesLists: any[];
  loading = false;
  avatarUrl?: string;
  switchValue = true;
  loadingSwitch = false;
  resourceCache: any;
  isHoveredGroupId:number;
  isDefaultGroup:boolean;

  @ViewChild(CourseListingComponent) childComponent: CourseListingComponent;
  @ViewChild(DataListingComponent) resourceComponent: DataListingComponent
 
  dataListingComponent: DataListingComponent;
  newlyAddedTags: any[] = [];
  tagMetaData: any;
  resource_category: any;
  resourceCategoryList: any[];
  resourceCategoryFilterList: any[];
  selectedTagValues: any[] = [];
  searchTerm: string;
  isArchived: boolean = false;
  listOfColumns: ColumnItem[] = [
    {
      name: 'Group',
      sortOrder: null,
      sortFn: (a: DataItem, b: DataItem) =>
        a.access_group_name.localeCompare(b.access_group_name),
      sortDirections: ['ascend', 'descend', null],
    },
    {
      name: 'Members',
      sortOrder: null,
      sortFn: (a: DataItem, b: DataItem) =>
        a.user_ids.length - b.user_ids.length,
      sortDirections: ['ascend', 'descend', null],
    },
    {
      name: 'Resources',
      sortOrder: null,
      sortFn: (a: DataItem, b: DataItem) =>
        a.resource_ids.length - b.resource_ids.length,
      sortDirections: ['ascend', 'descend', null],
    },
    {
      name: 'Tag',
      sortOrder: null,
      sortFn: (a: DataItem, b: DataItem) => {
        const tagA = a.tag.map((tagObj) => tagObj.tag_name).join(', ');
        const tagB = b.tag.map((tagObj) => tagObj.tag_name).join(', ');
        return tagA.localeCompare(tagB);
      },
      sortDirections: ['ascend', 'descend', null],
    },
    {
      name: 'Actions',
      sortOrder: null,
      sortFn: null,
      sortDirections: [],
    },
  ];
  sortOrder: NzTableSortOrder | null;
  sortFn: NzTableSortFn<DataItem> | null;
  lastRequestTime: string | null = null; // Store the last request time
  itemPerPage: number = 9; // Default items per page
  totalResourcesCount: number = 0; // Total resources count
  access_group_id : number
  assigned_resource_ids: number[] = [];
  // Stack to track navigation history
  scrollPositionMap = new Map<string, number>(); // folderId -> scrollTop
  checkboxActions = [];
  totalUserCount: number = 0;

  constructor(
    private fb: FormBuilder,
    private webapi: WebService,
    private groupService: GroupService,
    private resourceService: ResourceService,
    private knowledgeBaseService: KnowledgeBaseService,
    private courseService: CourseService,
    private userService: UserService,
    private notification: NzNotificationService,
    private modal: NzModalService
  ) {
    this.getGroupList({ filters: [] });
    // this.getAccessGroups();
    // this.getResources({ filters: [] });
    this.getKnowledgeBases({ filters: [] });
    this.getCourses({ filters: [] });
    this.getUsers();

    this.accessGroupForm = this.fb.group({
      access_group_name: [null, [Validators.required]],
      icon_path: [null],
      is_active: [true],
      tag_id: [[]],

    });

    this.resourceData = [];
    this.knowledgeBaseData = [];
    this.userData = [];
    this.getMetadata();
    // this.getGroupList({ filters: [] });
    this.tagFilterList = [];
    this.groupData = [];

    // this.loadBackgroundData()
  }


  listOfOption: string[] = [];
  listOfSelectedValue = ['a10', 'c12'];
  list = ['Group Tag', 'grouping tag'];

  confirmModal?: NzModalRef; // For testing by now

  showConfirm(): void {
    this.confirmModal = this.modal.confirm({
      nzTitle:
        'All unsaved changes will be lost. Do you wish to proceed with closing the form?',
      nzContent: '',
      nzCentered: true,
      nzOnOk: () => {
        this.accessGroupFormVisible = false;
      },
    });
  }

  originalFormValue: any;
  // checkFormState() {
  //   if (this.accessGroupForm.pristine && this.checkedResourceItems.length <= 0 && this.checkedKnowledgeBaseItems.length <= 0
  //     && this.checkedCourseItems.length <= 0 && this.checkedUserItems.length <= 0) {
  //     this.resetAccessGroupForm();
  //     this.accessGroupFormVisible = false;
  //   } else {
  //     this.showConfirm();
  //   }
  // }
  checkFormState() {
    if (this.isFormNotEmpty()) {
      this.showConfirm();
      return;
    }
    // Close the drawer if the form is empty
    this.accessGroupFormVisible = false;
  }
  // Method to set the original form value before patchValue is called
  setOriginalFormValue(): void {
    this.originalFormValue = { ...this.accessGroupForm.value };
  }
 
  // Updated hasFormChanged() method to check for value differences
  hasFormChanged(): boolean {
    if (!this.originalFormValue) {
      return false; // No original form value to compare (form not patched yet)
    }

    const formControls = this.accessGroupForm.controls;
    for (const controlName in formControls) {
      if (formControls.hasOwnProperty(controlName)) {
        const originalValue = this.originalFormValue[controlName];
        const currentValue = formControls[controlName].value;
        if (
          typeof currentValue === 'object' &&
          !this.isEqual(currentValue, originalValue) &&
          controlName != 'tag_id'
        ) {
          return true;
        } else if (controlName == 'tag_id') {
          if (
            typeof currentValue === 'object' &&
            !this.isEqual(currentValue, this.editTagValueHolder)
          ) {
            return true;
          }
        } else if (
          Array.isArray(originalValue) &&
          Array.isArray(currentValue)
        ) {
          if (!this.arraysAreEqual(originalValue, currentValue)) {
            return true;
          }
        } else if (originalValue != currentValue) {
          return true; // Found a difference in form values
        }
      }
    }
    if (this.checkBoxStateUpdate) return true;

    return false; // No differences found in form values
  }
  isEqual(objA: any, objB: any): boolean {
    // Quick shallow comparison for demonstration
    return JSON.stringify(objA) === JSON.stringify(objB);
  }
  arraysAreEqual(arr1: any[], arr2: any[]): boolean {
    if (arr1.length !== arr2.length) {
      return false;
    }

    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) {
        return false;
      }
    }

    return true;
  }

  isFormNotEmpty(): boolean {
    if (this.updateAccessGroupId) {
      if (this.hasFormChanged()) return true;
      else return false;
    } else {
      if (this.checkBoxStateUpdate) return true;
      // if (this.selectedEventLeads !== null && this.selectedEventLeads !== '') {
      //   return true;
      // }
      for (const controlName in this.accessGroupForm.controls) {
        if (this.accessGroupForm.controls.hasOwnProperty(controlName)) {
          const control = this.accessGroupForm.get(controlName);
          if (control) {
            const value = control.value;
            if (Array.isArray(value) && value.length > 0) {
              return true; // Array control has at least one item
            } else if (
              value !== null &&
              value !== '' &&
              value !== true &&
              !(Array.isArray(value) && value.length === 0)
            ) {
              return true; // Non-array control has a non-empty value
            }
          }
        }
      }
      if (
        this.checkedResourceItems.length > 0 ||
        this.checkedKnowledgeBaseItems.length > 0 ||
        this.checkedCourseItems.length > 0 ||
        this.checkedUserItems.length > 0
      ) {
        return true;
      }

      return false; // No form control has a non-empty value
    }
    // Check if any form control has a non-empty value
  }

  getDataFromChild(event){
    console.log("EVENT FROM CHILD", event);
    // Check if the event is an array and has elements
   
      this.resourceCache = event;


  }
  ngOnInit() {
    
  }

  ngAfterViewInit(): void {}

  get tagIdObject() {
    const selectedTagId = this.accessGroupForm.get('tag_id').value;
    return true;
  }

  addTagToAPI(tag: string) {
    return this.webapi.requestJson('addTag', { name: tag, tag_type: 'group' });
  }
  editTagValueHolder;
   fillAccessGroupForm(data: any) {
    this.openAccessGroupForm();
    console.log("this is access group id", data.access_group_id)
    // console.log("this is data.resource_ids", data.resource_ids)
    console.log("This is data", data)
    //  this.getResources({ filters: [] }, data.access_group_id, data.resource_ids);
     this.resource_ids = data.resource_ids;
     this.access_group_id = data.access_group_id;
    this.updateMode = true;
    const tagIds = data.tag.map((tag) => tag.tag_id);
    this.selectedTagValues = this.tagFilterList.filter((tag) =>
      tagIds.includes(tag.value)
    );
    this.editTagValueHolder = this.selectedTagValues;
    this.accessGroupForm.patchValue({
      access_group_name: data.access_group_name,
      icon_path: data.icon_path,
      is_active: data.is_active,
      is_default: data.is_default,
    });
    this.isDefaultGroup = data.is_default === 1 ? true : false;
    // this.resourcesList.forEach((item) => {
    //   item.checked = data.resource_ids.includes(item.resource_id);

    //   if (item.children && Array.isArray(item.children)) {
    //     item.children.forEach((child) => {
    //       child.checked =
    //         data.resource_ids.includes(child.resource_id) || item.checked;
    //     });
    //   }
    // });
    
    this.knowledgeBasesList.forEach((item) => {
      item.checked = data.knowledge_base_ids.includes(item.knowledge_base_id);
    });

    this.coursesList.forEach((item) => {
      item.checked = data.course_ids.includes(item.course_id);
    });

    this.usersList.forEach((item) => {
      item.checked = data.user_ids.includes(item.user_id);
    });

    this.checkResourceIds = data.resource_ids;
    this.updateAccessGroupId = data.access_group_id;
    this.rawUpdateData = { ...data };
    this.originalFormValue = this.accessGroupForm.value;

    this.checkBoxStateUpdate = false;
  }

  getSelectedResourceIds(): number[] | null {
    if (this.rawUpdateData && this.rawUpdateData.resource_ids) {
      return this.rawUpdateData.resource_ids;
    } else {
      return null;
    }
  }

  receiveDataFromChild(data: any[]) {
    this.receivedData = data;
  }

  getAccessGroups(): void {
    this.groupService.getAccessGroups().then((results) => {
      this.accessGroupList = this.groupService.accessGroupList;
    });
  }

  rootResources: any = [];
  buildResourceHierarchy(data) {
    this.original = [...data];
    const resourcesMap = new Map();

    data.forEach((item) => {
      const resourceId = item.resource_id;
      const parentFolder = item.parent_folder;

      const resource = {
        resource_id: resourceId,
        resource_name: item.resource_name,
        is_folder: item.is_folder,
        parent_folder: item.parent_folder,
        resource_path: item.resource_path,
        resource_url: item.resource_url,
        size: item.size,
        uploaded_date: item.uploaded_date,
        expires_date: item.expires_date,
        category_id: item.category_id,
        category_name: item.category_name,
        tag: item.tag || [],
        user:
          item.first_name && item.last_name
            ? [`${item.first_name} ${item.last_name}`]
            : [],
        group_names: item.group_names,
      };

      if (parentFolder === null) {
        this.rootResources.push(resource);
      }

      resourcesMap.set(resourceId, resource);

      if (parentFolder !== null) {
        const parentResource = resourcesMap.get(parentFolder);
        if (parentResource) {
          if (!parentResource.children) {
            parentResource.children = [];
          }
          parentResource.children.push(resource);
        }
      }
    });

    return this.rootResources;
  }

  // getResources(): void {
  //   this.resourceService.getResources().then((results) => {
  //     this.resourcesList = this.resourceService.resourcesList;
  //     // this.resourcesList = this.buildResourceHierarchy(this.resourcesList);
  //     // this.tableDataRaw = cloneDeep(this.resourcesList);
  //   });
  // }

  getResources({ filters }, access_group_id?, assigned_resource_ids?): void {

    this.lastRequestTime = this.lastRequestTime ? this.lastRequestTime :  localStorage.getItem("lastRequestTime");
      const obj = {
        request_page: 1,
        items_per_page: this.itemPerPage,
        search: "",
        sort: [],
        parent_id: null,
        timestamp: this.lastRequestTime || "",
        existing_resources: [],
        filters: filters.map((file) => {
          return {
            Key: file.key,
            Values: file.values,
          };
        }),
        access_group_id: access_group_id ? access_group_id : null,
        assigned_resource_ids: assigned_resource_ids ? assigned_resource_ids : []
      }

    this.webapi
      .requestJson('getPaginatedResource', obj)
      .subscribe(
        (data) => {
          let response = JSON.parse(data.body);
          console.log("this is response", response)
          this.resourcesList = [...response.data.data];
          console.log("this is resourcesList", this.resourcesList)

          this.updateResourceCheckedState()

          //set the total resource count in local storage
          localStorage.setItem('totalResourceCount', response.data.total_resources_count.toString());
          localStorage.setItem('lastRequestTime', response.data.timestamp.toString());

        },
        (error) => {
          console.log('ERROR', error);
          // this.isLoading = false;
          this.createNotification('error', '', 'An error occurred. Please try again later.');
        }
      );
  }
  updateResourceCheckedState() {

    //Convert 'checked' and 'unchecked' to true and false and add mixedState and assign true when its intermediate  other wise false
    this.resourcesList.forEach((item) => {
      if(item.checked === 'checked'){
        item.checked = true;
        item.mixedState = false;

      }
      if (item.checked === 'unchecked') {
        item.checked = false;
        item.mixedState = false;

      }
      //If checked is 'mixedState' then remove the 
      if (item.checked === 'mixedState') {
        item.mixedState = true;
        item.checked = false;
        
      }
      
    });
    
  }
  // getResources({ filters }): void {
    
  //   this.webapi
  //     .requestJson('getResource', {
  //       Filters: filters.map((file) => {
  //         return {
  //           Key: file.key,
  //           Values: file.values,
  //         };
  //       }),
  //     })
  //     .subscribe(
  //       (data) => {
  //         let response = JSON.parse(data.body);
  //         this.resourcesList = [...response.data];
          
  //       },
  //       (error) => {
  //         console.log('ERROR', error);
  //         // this.isLoading = false;
  //         this.createNotification('error', '', 'An error occurred. Please try again later.');
  //       }
  //     );
  // }

  getKnowledgeBases({ filters }): void {
    this.webapi
      .requestJson('getKnowledgeBase', {
        Filters: filters.map((file) => {
          return {
            Key: file.key,
            Values: file.values,
          };
        }),
      })
      .subscribe(
        (data) => {
          let response = JSON.parse(data.body);
          this.knowledgeBasesList = [...response.data];
        },
        (error) => {
          console.log('ERROR', error);
          // this.isLoading = false;
          this.createNotification('error', '', 'An error occurred. Please try again later.');
        }
      );
  }

  getCourses({ filters }): void {
    this.webapi
      .requestJson('getCourse', {
        Filters: filters.map((file) => {
          return {
            Key: file.key,
            Values: file.values,
          };
        }),
      })
      .subscribe(
        (data) => {
          let response = JSON.parse(data.body);
          this.coursesList = [...response.data];
        },
        (error) => {
          console.log('ERROR', error);
          // this.isLoading = false;
          this.createNotification('error', '', 'An error occurred. Please try again later.');
        }
      );
  }

  getGroupList({ filters }): void {
    this.showLoad = true;
    this.webapi
      .requestJson('getGroup', {
        Filters: filters.map((file) => {
          return {
            Key: file.key,
            Values: file.values,
          };
        }),
      })
      .subscribe(
        (data) => {
          let response = JSON.parse(data.body);
          this.groupData = [...response.data];
          this.groupData.forEach((group) => {
            group.checked = false;
          });
          this.sortDefaultFirst();
          this.groupDataRaw = cloneDeep(this.groupData);
          this.showLoad = false;
        },
        (error) => {
          console.log('ERROR', error);
          this.showLoad = false;
          this.createNotification('error', '', 'An error occurred. Please try again later.');
        }
      );
  }

  // getKnowledgeBases(): void {
  //   this.knowledgeBaseService.getKnowledgeBases().then((results) => {
  //     this.knowledgeBasesList = this.knowledgeBaseService.knowledgeBaseList;
  //   });
  // }

  // getCourses(): void {
  //   this.courseService.getCourses().then((results) => {
  //     this.coursesList = this.courseService.courseList;
  //   });
  // }

  getUsers(): void {
    this.userService.getUsers().then((results) => {
      this.usersList = this.userService.userList.filter((user)=> user.first_name !== null);
      console.log("this is userList", this.userList)
      this.totalUserCount = this.usersList.length;
    });
  }

  getMetadata(): void {
    this.webapi
      .requestJson('getMetaData', {
        metadata: ['group_tags', 'resource_category'],
      })
      .subscribe(
        (data) => {
          let response = JSON.parse(data.body);
          this.metadata = cloneDeep(response.data);
          sessionStorage.setItem("access-group",this.metadata);
          // this.groupClone = [...this.metadata['group']];
          // this.groupData = [...this.metadata['group']];
          // this.groupData = this.groupData.filter(
          //   (group) => group.is_deleted === 0
          // );
          if (this.metadata.groupTagCategory) {
            this.tagMetaData = this.metadata.groupTagCategory;
            this.tagList = [...this.tagMetaData];
            this.tagFilterList = [];
            this.tagList.forEach((element) => {
              this.tagFilterList.push({
                text: element.name,
                value: element.tag_id,
                byDefault: false,
              });
            });
          }
          if (this.metadata.resourceCategory) {
            this.tagMetaData = this.metadata.resourceCategory;
            this.resourceCategoryList = [...this.tagMetaData];
            this.resourceCategoryFilterList = [];
            this.resourceCategoryList.forEach((element) => {
              this.resourceCategoryFilterList.push({
                text: element.name,
                value: element.resource_category_id,
                byDefault: false,
              });
            });
          }
          // this.groupData.forEach((group) => {
          //   group.checked = false;
          // });
          // this.groupDataRaw = cloneDeep(this.groupData);
        },
        (error) => {
          this.toast.error({
            title: 'Error',
            theme: 'bootstrap',
            timeout: 3000,
          });
        }
      );
  }

  openAccessGroupForm(): void {
    this.resetAccessGroupForm();
    this.selectedTagValues = [];
    this.accessGroupForm.get('is_active').setValue(true);
    // this.accessGroupForm.get('is_active').setValue(true);
    this.checkedResourceItems = [];
    this.checkedKnowledgeBaseItems = [];
    this.checkedCourseItems = [];
    this.checkedUserItems = [];
    this.checkBoxStateUpdate = false;
    this.resource_ids = [];
    this.access_group_id = null;
    this.isDefaultGroup = false;
    // this.accessGroupForm.get('is_active').setValue(true);
    this.checkedR = [];
    if (this.resourcesList) {
      this.resourcesList.forEach((item) => {
        item.checked = false;
      });
    }

    this.checkedK = [];
    if (this.knowledgeBasesList) {
      this.knowledgeBasesList.forEach((item) => {
        item.checked = false;
      });
    }

    this.checkedC = [];
    if (this.coursesList) {
      this.coursesList.forEach((item) => {
        item.checked = false;
      });
    }

    this.checkedU = [];

    if (this.usersList) {
      this.usersList.forEach((item) => {
        item.checked = false;
      });
    }
    this.visible = false;
    this.accessGroupFormVisible = true;
  }

  resourceData: any[] = [];
  knowledgeBaseData: any[] = [];
  courseData: any[] = [];
  userData: any[] = [];
  checkBoxStateUpdate = false;
  onCheckedItemsChanged(event) {
    let [checkedItems, checkboxActiondata] = event;
    console.log("checkedItems", checkedItems)
    this.checkBoxStateUpdate = true;
    this.checkedResourceItems = checkedItems;
    this.checkboxActions = checkboxActiondata;
    console.log("this is checkboxActions inside access group",this.checkboxActions)
  }

  onCheckedItemsKnowledgeBase(checkedItems: any[]) {
    this.checkBoxStateUpdate = true;
    this.checkedKnowledgeBaseItems = checkedItems;
  }

  onAllCheckedKnowledgeBase(allChecked: boolean): void {
    this.allChecked = allChecked;
  }

  onCheckedItemsCourse(checkedItems: any[]) {
    this.checkBoxStateUpdate = true;
    this.checkedCourseItems = checkedItems;
  }

  onCheckedItemsUser(checkedItems: any[]) {
    this.checkBoxStateUpdate = true;
    this.checkedUserItems = checkedItems;
  }

  selectedValue: string;

  onChildValueSelected(value: string) {
    this.selectedValue = value;
  }

  addNewTagToAPI(tagValue) {
    return this.webapi.requestJson('addTag', {
      name: tagValue,
      tag_type: 'group',
    });
  }

  submitAccessGroup() {
    this.isArchived = false;
    this.archived = false;
    this.isLoading = true;
    const tagIdValue = this.accessGroupForm.get('tag_id').value;
    if (!Array.isArray(tagIdValue)) {
      return;
    }

    const addTagsFunction = () => {
      const newTagIds = [];
      const existingTagIds = [];

      const newTagObservables = tagIdValue
        .filter((tagValue) => typeof tagValue !== 'object')
        .map((tagValue) => this.addNewTagToAPI(tagValue));

      from(newTagObservables)
        .pipe(concatMap((observable) => observable))
        .subscribe(
          (data) => {
            let response = JSON.parse(data.body);
            if (response.tagId !== undefined) {
              newTagIds.push(response.tagId);
            }
          },
          (error) => {},
          () => { 
            tagIdValue
              .filter((tagValue) => typeof tagValue === 'object')
              .forEach((tagValue) => {
                existingTagIds.push(tagValue.value);
              });

            this.addGroupWithTags(newTagIds, existingTagIds);
          }
        );
    };

    addTagsFunction();
  }

  addGroupWithTags(newTagIds, existingTagIds) {
    const isSwitchOn = this.accessGroupForm.get('is_active').value;
    let obj = {
      ...this.accessGroupForm.value,
      is_active: isSwitchOn,
      tag_id: newTagIds.concat(existingTagIds),
      // resource_id: this.checkedResourceItems,
      resource_actions: this.checkboxActions,
      knowledge_base_id: this.checkedKnowledgeBaseItems,
      course_id: this.checkedCourseItems,
      user_id: this.checkedUserItems,
    };

    this.webapi.requestJson('addGroup', obj).subscribe(
      (data) => {
        let response = JSON.parse(data.body);
        this.isLoading = false;
        this.createNotification('success', '', response['message']);
        // this.getGroupList({ filters: [] });
        this.filterAccessGroupData()
        this.closeAccessGroupForm();
        this.resetSubmitGroup()

        // this.groupData = [...response.data];
        // this.groupData.forEach((group) => {
        //   group.checked = false;
        // });
        // this.groupDataRaw = cloneDeep(this.groupData);
      },
      (error) => {
        this.isLoading = false;
        this.createNotification('error', '', 'An error occurred. Please try again later.');
      }
    );
  }

  updateAccessGroup(): void {
    let updateObj = {
      access_group_id: this.updateAccessGroupId,
      ...this.accessGroupForm.value,
    };
    const addTagsFunction = () => {
      const newTagIds = [];
      const existingTagIds = [];

      const newTagObservables = updateObj.tag_id
        .filter((tagValue) => typeof tagValue !== 'object')
        .map((tagValue) => this.addNewTagToAPI(tagValue));

      from(newTagObservables)
        .pipe(concatMap((observable: Observable<any>) => observable))
        .subscribe(
          (data) => {
            let response = JSON.parse(data.body);
            if (response.tagId !== undefined) {
              newTagIds.push(response.tagId);
            }
          },
          (error) => {},
          () => {
            updateObj.tag_id
              .filter((tagValue) => typeof tagValue === 'object')
              .forEach((tagValue) => {
                existingTagIds.push(tagValue.value);
              });

            this.updateGroupWithTags(newTagIds, existingTagIds);
          }
        );
    };

    addTagsFunction();
  }

  createNotification(type, title, msg): void {
    this.notification.create(type, title, msg);
  }

  closeAccessGroupForm(): void {
    this.resetAccessGroupForm();
    this.accessGroupData = cloneDeep(this.accessGroupDataRaw);
    this.accessGroupFormVisible = false;
  }
  selectInvalid(controls) {
    return { 'selectOption-invalid': this.submitted && controls };
  }

  private getBase64(img: File, callback: (img: string) => void): void {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result!.toString()));
    reader.readAsDataURL(img);
  }

  handleChange(info: { file: NzUploadFile }): void {
    switch (info.file.status) {
      case 'uploading':
        this.loading = true;
        break;
      case 'done':
        this.getBase64(info.file!.originFileObj!, (img: string) => {
          this.loading = false;
          this.avatarUrl = img;
        });
        break;
      case 'error':
        this.loading = false;
        break;
    }
  }

  updateGroupWithTags(newTagIds, existingTagIds) {
    this.isLoading = true;
    let resourceIds =[];
    //Found those resource which are not loaded but assigned to users (Now add these resources to currrent items)
    console.log("this.checkedResourceItems", this.checkedResourceItems)
    console.log("this.resource_ids", this.resource_ids)

    // let uniqueResourceIds = Array.from(
    //   new Set([...this.checkedResourceItems, ...this.resource_ids.filter(item => !this.resourceCache.has(item))])
    // );
    // let uniqueResourceIds = Array.from(
    //   new Set([...this.checkedResourceItems])
    // );
    // console.log("this is uniqueResourceIds", uniqueResourceIds)

    // const checkedResources = this.resourcesList.filter(
    //   (item) =>
    //     item.checked ||
    //     (item.children &&
    //       item.children.some((child) => {
    //         return child.checked;
    //       }))
    // );

    // const resourceIds = checkedResources.flatMap((item) => {
    //   const ids = [item.resource_id];
    //   if (item.children) {
    //     const checkedChildrenIds = item.children
    //       .filter((child) => child.checked)
    //       .map((child) => child.resource_id);

    //     ids.push(...checkedChildrenIds);
    //   }
    //   return ids;
    // });

    const checkedKnowledgeBases = this.knowledgeBasesList.filter(
      (item) => item.checked
    );

    const knowledgeBaseIds = checkedKnowledgeBases.map(
      (item) => item.knowledge_base_id
    );
    const checkedCourses = this.coursesList.filter((item) => item.checked);

    const courseIds = checkedCourses.map((item) => item.course_id);

    const checkedUsers = this.usersList.filter((item) => item.checked);

    const userIds = checkedUsers.map((item) => item.user_id);
    let combineTagIds = newTagIds.concat(existingTagIds);
    console.log("this is updatdAccessGroupId",this.updateAccessGroupId)
    let updateObj = {
      access_group_id: this.updateAccessGroupId,
      ...this.accessGroupForm.value,
      tag_id: newTagIds.concat(existingTagIds),
      // resource_id: uniqueResourceIds,
      resource_actions: this.checkboxActions,
      knowledge_base_id: knowledgeBaseIds,
      course_id: courseIds,
      user_id: userIds,
    };
    console.log("this is updateObj", updateObj)
    this.webapi.requestJson('updateGroup', updateObj).subscribe(
      (data) => {
        let response = JSON.parse(data.body);
        this.isLoading = false;
        this.createNotification('success', '', response['message']);
        this.getGroupList({ filters: [] });
        this.closeAccessGroupForm();
        this.resetSubmitGroup()
        // this.groupData = [...response.data];
        // this.groupData.forEach((group) => {
        //   group.checked = false;
        // });
        // this.groupDataRaw = cloneDeep(this.groupData);
      },
      (error) => {
        this.isLoading = false;
        this.createNotification('error', '', 'An error occurred. Please try again later.');
      }
    );
  }

  resetSubmitGroup() {
    console.log("this is resetSubmitGroup")

    // Call the reset function in the child
    if (this.resourceComponent) {
      this.resourceComponent.resetResourceCache();
    }
  }
  checkAll(value: boolean): void {
    this.groupData.forEach((data) => {
      if(data.is_default !== 1){//prevent default group from being checked/unchecked

        data.checked = value;
      }
    });
    this.refreshStatus();
  }

  refreshStatus(): void {
    this.checkedData = [];
    this.groupData.forEach((element) => {
      if (element.checked) {
        this.checkedData.push(element.access_group_id);
      }
    });
    this.anyChecked = this.groupData.some((e) => e.checked);
    this.allChecked = this.groupData.every((e) => e.checked);
  }

  deleteAccessGroup(accessGroupId: number = null, multi = false): void {
    this.showLoad = true;
    let obj = {
      access_group_id: [accessGroupId],
    };
    if (multi) {
      obj.access_group_id = [];
      obj.access_group_id = this.checkedData;
    }
    

    this.webapi.requestJson('deleteGroup', obj).subscribe(
      (data) => {
        let response = JSON.parse(data.body);
        // this.isLoading = false;
        this.createNotification('success', '', 'Deletion successful.');
        this.getGroupList({ filters: [] });

        this.anyChecked = false;
        // this.showLoad = false;

      },
      (error) => {
        this.createNotification('error', '', 'An error occurred. Please try again later.');
        this.getGroupList({ filters: [] });

        this.anyChecked = false;
        // this.showLoad = false;

      }
    );
  }

  onKeyUp(query: string): void {
    this.searchTerm = query;
    if (query) {
      let q: string;
      q = query.toLowerCase();
      const searchData = this.groupDataRaw.filter((d) => {
        var found = false;
        d.tag.forEach((tag) => {
          if (tag.tag_name.toLowerCase().includes(q)) {
            found = true;
          }
        });
        if (
          (d.access_group_name &&
            d.access_group_name.toLowerCase().includes(q)) ||
          d.resource_ids.length.toString().includes(q) ||
          d.user_ids.length.toString().includes(q) ||
          found
        ) {
          return d;
        }
      });
      this.groupData = searchData;
      this.groupData = [...this.groupData];
    } else {
      this.groupData = [...this.groupDataRaw];
    }
  }

  resetAccessGroupForm(): void {
    // const is_activeValue = this.accessGroupForm.get('is_active').value;
    this.accessGroupForm.reset();
    this.accessGroupForm.get('is_active').setValue(true);
    // this.accessGroupForm.get('is_active').patchValue(is_activeValue);
    this.updateMode = false;
    this.updateAccessGroupId = undefined;
    this.rawUpdateData = {};
    if (this.resourcesList) {
      this.checkedR = [];
      this.resourcesList.forEach((item) => {
        item.checked = false;
      });
    }
    if (this.knowledgeBasesList) {
      this.checkedK = [];
      this.knowledgeBasesList.forEach((item) => {
        item.checked = false;
      });
    }
    if (this.coursesList) {
      this.checkedC = [];
      this.coursesList.forEach((item) => {
        item.checked = false;
      });
    }
    if (this.usersList) {
      this.checkedU = [];
      this.usersList.forEach((item) => {
        item.checked = false;
      });
    }

    this.originalFormValue = this.accessGroupForm.value;
  }

  resetUpdateForm(): void {
    const tagIds = this.rawUpdateData.tag.map((tag) => tag.tag_id);
    this.selectedTagValues = this.tagFilterList.filter((tag) =>
      tagIds.includes(tag.value)
    );
    // this.accessGroupForm.controls.tag_id.setValue(tagIds);
    this.accessGroupForm.patchValue(this.rawUpdateData);

    // this.accessGroupForm.patchValue(this.rawUpdateData);
    this.resourcesList.forEach((item) => {
      item.checked = this.rawUpdateData.resource_ids.includes(item.resource_id);
    });
    this.knowledgeBasesList.forEach((item) => {
      item.checked = this.rawUpdateData.knowledge_base_ids.includes(
        item.knowledge_base_id
      );
    });
    this.coursesList.forEach((item) => {
      item.checked = this.rawUpdateData.course_ids.includes(item.course_id);
    });
    this.usersList.forEach((item) => {
      item.checked = this.rawUpdateData.user_ids.includes(item.user_id);
    });
  }

  // applyAccessGroupFilter() {
  //   if (this.archived) {
  //     this.groupData = this.groupClone.filter(
  //       (group) => group.is_deleted === 1
  //     );
  //     this.filterVisible = false;
  //   } else {
  //     this.getMetadata();
  //     this.filterVisible = false;
  //   }
  // }

  clickSwitch() {
    const isSwitchOn = this.accessGroupForm.get('is_active').value;
    this.accessGroupForm.get('is_active').setValue(!isSwitchOn);
  }

  filterAccessGroupData() {
    this.appliedFilters = [];

    // if (this.isUsedInLast30Days) {
    //   this.appliedFilters.push({ key: 'status', values: ['0'] });
    //   this.filterVisible = false;
    // }

    if (this.active) {
      this.appliedFilters.push({ key: 'status', values: ['1'] });
      this.filterVisible = false;
      this.isArchived = false;
      
    }

    if (this.archived) {
      this.appliedFilters.push({ key: 'status', values: ['2'] });
      this.filterVisible = false;
      this.isArchived = true;
    }
    this.getGroupList({ filters: this.appliedFilters });
    this.filterVisible = false;
  }
  // filterAccessGroupData() {
  //   this.appliedFilters = [];

  //   if (this.isUsedInLast30Days) {
  //     this.appliedFilters.push({ key: 'status', values: ['0'] });
  //     // this.filterVisible = false;
  //   }

  //   if (this.active) {
  //     this.appliedFilters.push({ key: 'status', values: ['1'] });
  //     // this.filterVisible = false;
  //   }

  //   if (this.archived) {
  //     this.appliedFilters.push({ key: 'status', values: ['2'] });
  //     // this.filterVisible = false;
  //   }

  //   this.getGroupList({ filters: this.appliedFilters });
  //   this.filterVisible = false;
  // }

  clickFilter() {
    this.filterVisible = false;
    if (this.appliedFilters && this.appliedFilters.length > 0) {
      // this.isUsedInLast30Days = this.appliedFilters.some(filter => filter.values.includes('0'));
      this.active = this.appliedFilters.some((filter) =>
        filter.values.includes('1')

      );
      this.archived = this.appliedFilters.some((filter) =>
        filter.values.includes('2')
      );
    } else {
      this.isUsedInLast30Days = false;
      this.active = false;
      this.archived = false;
      this.isArchived = false;
    }
  }

  onPopoverVisibleChange(visible: boolean) {
    if (!visible) {
      this.clickFilter();
    } else {
      console.log('Popover is now visible');
    }
  }


  resetSearch() {
    this.searchTerm = '';
    this.groupData = [...this.groupDataRaw];

  }
  rowHoverEnter(groupId){
    console.log("Mouse enter event triggered");
    this.isHoveredGroupId = groupId;
  }
  rowHoverExit(){
    console.log("Mouse exist event triggered");

    this.isHoveredGroupId = -1;
  }

  updateGroupDefaultStatus(groupId: number) {
    this.isLoading = true;
    this.showLoad = true;
        this.webapi
          .requestJson('updateGroupDefaultStatus', { access_group_id: groupId, is_default: 1 })
          .subscribe(
            (data) => {
              let response = JSON.parse(data.body);
             
              this.createNotification('success', '', response['message']);
              this.filterAccessGroupData;
              this.groupDataRaw.forEach((group) => {
                if(group.access_group_id === groupId){
                  group.is_default = 1;
                } 
                else{
                  group.is_default = 0;
                }
              }
              );
              this.groupData = [...this.groupDataRaw];
              this.sortDefaultFirst();
              // this.getGroupList({ filters: [] });
              this.isLoading = false;
              this.showLoad = false;
            },
            (error) => {
              this.isLoading = false;
              this.showLoad = false;

              this.createNotification('error', '', 'An error occurred. Please try again later.');
            }
          );

  }

  setGroupAsDefault(event,groupId: number) {
    console.log("Event is", event);

    event.preventDefault();
    event.stopPropagation();

    let groupName = this.groupData.find(g => g.access_group_id == groupId)?.access_group_name;
    let currDefaultGroup = this.groupData.find(g => g.is_default == 1)?.access_group_name;

    console.log("this is present default group",currDefaultGroup);
    console.log("Group Name:", groupName);

    this.modal.confirm({
       nzTitle: `Set '${groupName}' as the default group? ${currDefaultGroup ? 'This will remove the current default group setting.' : ''}`,

nzContent: `All user activity associated with the '${currDefaultGroup}' group will be reset. Are you sure you want to continue?`,

        nzOkText: 'Yes',
        nzOkType: 'primary',
        nzCentered: true,
        nzOnOk: () => {
          this.updateGroupDefaultStatus(groupId)
        },
      });

   
  }

  sortDefaultFirst() {
    //Keep all default groups as it is just bring the default group to top
    this.groupData.sort((a, b) => b.is_default - a.is_default);
    this.groupData = [...this.groupData];


  }
  // filterAccessGroupData() {
  //   this.isLoading = true;
  //   if (this.active && this.archived) {
  //     this.groupData = this.groupClone.filter((group) => {
  //       this.isLoading = false;
  //       this.filterVisible = false;
  //       return group.is_active || group.is_deleted;
  //     });
  //   } else {
  //     this.groupData = this.groupClone.filter((group) => {
  //       this.isLoading = false;
  //       this.filterVisible = false;
  //       return (
  //         (!this.active || group.is_active) &&
  //         (!this.archived || group.is_deleted)
  //         // &&
  //         // (!this.usedInLast30Days || this.isEventInLast30Days(event))
  //       );
  //     });
  //   }
  //   if (!this.active && !this.archived && !this.usedInLast30Days) {
  //     this.isLoading = false;
  //     this.filterVisible = false;
  //     this.groupData = [...this.groupDataRaw];
  //   }
  // }
}
